import { render, staticRenderFns } from "./SysRegisterCode.vue?vue&type=template&id=0a970522"
import script from "./SysRegisterCode.vue?vue&type=script&lang=js"
export * from "./SysRegisterCode.vue?vue&type=script&lang=js"
import style0 from "./SysRegisterCode.vue?vue&type=style&index=0&id=0a970522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports